import {
  StaffDueDateExtensionResponse, StaffExpenseReportDetailResponse, StaffExpenseReportResponse,
  StaffSupportDocumentResponse,
} from "lib-klab-sdks";
import {
  ExpenseDueDateExtension, ExpenseReport, ExpenseReportDetail, ExpenseSupportDocument,
} from "../../../domain/models/accounting/expense-report.model";

export function mapExpenseReport(source: StaffExpenseReportResponse): ExpenseReport {
  return { expenseReportId: source.expenseReportId, requirementId: source.requirementId, status: source.status };
}

export function mapExpenseSupportDocument(source: StaffSupportDocumentResponse): ExpenseSupportDocument {
  return { supportDocumentId: source.supportDocumentId, expenseReportId: source.expenseReportId, fileName: source.fileName, status: source.status };
}

export function mapExpenseDueDateExtension(source: StaffDueDateExtensionResponse): ExpenseDueDateExtension {
  return { dueDateExtensionId: source.dueDateExtensionId, expenseReportId: source.expenseReportId, requestedDueDate: source.requestedDueDate, status: source.status };
}

export function mapExpenseReportDetail(source: StaffExpenseReportDetailResponse): ExpenseReportDetail {
  return {
    expenseReportId: source.expenseReportId,
    requirementId: source.requirementId,
    currencyCode: source.currencyCode,
    dueDate: source.dueDate,
    status: source.status,
    requestedAmount: source.requestedAmount,
    submittedAmount: source.submittedAmount,
    pendingSubmissionAmount: source.pendingSubmissionAmount,
    documents: (source.documents ?? []).map(mapExpenseSupportDocument),
    extensions: (source.extensions ?? []).map(mapExpenseDueDateExtension),
  };
}
